export const MAXIMUM_ATTACHMENTS_SIZE = 31457280;
export const INVALID_FILE_TYPES = new Set([
    ".ade",
    ".adp",
    ".apk",
    ".appx",
    ".appxbundle",
    ".bat",
    ".cab",
    ".chm",
    ".cmd",
    ".com",
    ".cpl",
    ".dll",
    ".dmg",
    ".exe",
    ".hta",
    ".ins",
    ".isp",
    ".iso",
    ".jar",
    ".js",
    ".jse",
    ".lib",
    ".lnk",
    ".mde",
    ".msc",
    ".si",
    ".msix",
    ".msixbundle",
    ".msp",
    ".mst",
    ".nsh",
    ".pif",
    ".ps1",
    ".scr",
    ".sct",
    ".shb",
    ".sys",
    ".vb",
    ".vbe",
    ".vbs",
    ".vxd",
    ".wsc",
    ".wsf",
    ".wsh",
]);
